/* eslint max-nested-callbacks: ["error", 8] */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('../../utils'),
    resolvePath = _require.resolvePath,
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var pinManager = _ref.pinManager,
      gcLock = _ref.gcLock,
      dag = _ref.dag;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paths, options) {
      var recursive, cids, pinAdd, lock, release;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};
              recursive = options.recursive !== false;
              _context2.next = 4;
              return resolvePath(dag, paths, {
                signal: options.signal
              });

            case 4:
              cids = _context2.sent;

              pinAdd = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var results, _iterator, _step, cid, key, pinset;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          results = []; // verify that each hash can be pinned

                          _iterator = _createForOfIteratorHelper(cids);
                          _context.prev = 2;

                          _iterator.s();

                        case 4:
                          if ((_step = _iterator.n()).done) {
                            _context.next = 24;
                            break;
                          }

                          cid = _step.value;
                          key = cid.toBaseEncodedString();

                          if (!recursive) {
                            _context.next = 16;
                            break;
                          }

                          if (!pinManager.recursivePins.has(key)) {
                            _context.next = 11;
                            break;
                          }

                          // it's already pinned recursively
                          results.push(cid);
                          return _context.abrupt("continue", 22);

                        case 11:
                          _context.next = 13;
                          return pinManager.fetchCompleteDag(key, {
                            preload: options.preload,
                            signal: options.signal
                          });

                        case 13:
                          // found all objects, we can add the pin
                          results.push(cid);
                          _context.next = 22;
                          break;

                        case 16:
                          if (!pinManager.recursivePins.has(key)) {
                            _context.next = 18;
                            break;
                          }

                          throw new Error("".concat(key, " already pinned recursively"));

                        case 18:
                          if (pinManager.directPins.has(key)) {
                            _context.next = 21;
                            break;
                          }

                          _context.next = 21;
                          return dag.get(cid, {
                            preload: options.preload
                          });

                        case 21:
                          results.push(cid);

                        case 22:
                          _context.next = 4;
                          break;

                        case 24:
                          _context.next = 29;
                          break;

                        case 26:
                          _context.prev = 26;
                          _context.t0 = _context["catch"](2);

                          _iterator.e(_context.t0);

                        case 29:
                          _context.prev = 29;

                          _iterator.f();

                          return _context.finish(29);

                        case 32:
                          // update the pin sets in memory
                          pinset = recursive ? pinManager.recursivePins : pinManager.directPins;
                          results.forEach(function (cid) {
                            return pinset.add(cid.toString());
                          }); // persist updated pin sets to datastore

                          _context.next = 36;
                          return pinManager.flushPins();

                        case 36:
                          return _context.abrupt("return", results.map(function (cid) {
                            return {
                              cid: cid
                            };
                          }));

                        case 37:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 26, 29, 32]]);
                }));

                return function pinAdd() {
                  return _ref2.apply(this, arguments);
                };
              }(); // When adding a file, we take a lock that gets released after pinning
              // is complete, so don't take a second lock here


              lock = Boolean(options.lock);

              if (lock) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", pinAdd());

            case 9:
              _context2.next = 11;
              return gcLock.readLock();

            case 11:
              release = _context2.sent;
              _context2.prev = 12;
              _context2.next = 15;
              return pinAdd();

            case 15:
              _context2.prev = 15;
              release();
              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[12,, 15, 18]]);
    }));

    function add(_x, _x2) {
      return _add.apply(this, arguments);
    }

    return add;
  }());
};